export const parseFlexibleNumber = (input: string): number => {
  const clean = input.trim();

  // If already a simple number (no separators other than maybe one dot)
  if (/^-?\d+(\.\d+)?$/.test(clean)) {
    return parseFloat(clean);
  }

  const lastComma = clean.lastIndexOf(',');
  const lastDot = clean.lastIndexOf('.');

  // Mixed separators: 1.000.000,00 or 1,000,000.00
  if (lastComma !== -1 && lastDot !== -1) {
    if (lastComma > lastDot) {
      // EU format: 1.234,56
      return parseFloat(clean.replace(/\./g, '').replace(',', '.'));
    }
    // US format: 1,234.56
    return parseFloat(clean.replace(/,/g, ''));
  }

  // Single separator type
  if (lastComma !== -1) {
    // Check if it looks like a group separator (multiple commas or 3 digits after)
    const parts = clean.split(',');
    // If multiple commas, it's definitely groupings: 1,000,000
    if (parts.length > 2) {
      return parseFloat(clean.replace(/,/g, ''));
    }
    // Single comma. Ambiguous: 1,000 (1k) vs 1,000 (1.0).
    // Heuristic: if exactly 3 digits after, assume group. Else decimal.
    const lastPart = parts[parts.length - 1];
    if (lastPart.length === 3) {
      return parseFloat(clean.replace(/,/g, ''));
    }
    // Assume decimal
    return parseFloat(clean.replace(',', '.'));
  }

  if (lastDot !== -1) {
    const parts = clean.split('.');
    if (parts.length > 2) {
      return parseFloat(clean.replace(/\./g, ''));
    }
    const lastPart = parts[parts.length - 1];
    if (lastPart.length === 3) {
      return parseFloat(clean.replace(/\./g, ''));
    }
    return parseFloat(clean);
  }

  return parseFloat(clean);
};
